import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { MatTableModule, MatTableDataSource } from '@angular/material/table'
import { FornecedorCotacaoPortalVm } from '../../../core/models/supplier-portal.model'
import {
  labelStatus,
  podeResponder,
  STATUS_ITEM,
} from '../../../features/supplier-portal/supplier-portal-quote-status.util'

// Listagem das solicitações de cotação do Portal do Fornecedor. Mesma forma de
// table-list-supplier-portal-os (mat-table dirigido por columns[]), com as colunas do trecho
// a cotar. Uma linha é um fornecedor_cotacao_item — nunca aparece linha de outro fornecedor.
@Component({
  selector: 'table-list-supplier-portal-quote',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule, MatTableModule],
  templateUrl: './table-list-supplier-portal-quote.component.html',
  styleUrl: './table-list-supplier-portal-quote.component.scss',
})
export class TableListSupplierPortalQuoteComponent implements OnInit, OnChanges {
  @Input() dataSource: FornecedorCotacaoPortalVm[] = []
  @Input() columns: any[] = []

  @Output() openItem = new EventEmitter<FornecedorCotacaoPortalVm>()

  displayedColumns: string[] = []
  tableSource = new MatTableDataSource<FornecedorCotacaoPortalVm>()

  readonly statusRecusado = STATUS_ITEM.RECUSADO_FORNECEDOR

  ngOnInit() {
    this.displayedColumns = this.columns.map((obj: any) => obj.keyColumn)
    this.tableSource = new MatTableDataSource<FornecedorCotacaoPortalVm>(this.dataSource)
  }

  ngOnChanges() {
    this.tableSource.data = this.dataSource
  }

  openItemEvent(item: FornecedorCotacaoPortalVm): void {
    this.openItem.emit(item)
  }

  podeResponder(item: FornecedorCotacaoPortalVm): boolean {
    return podeResponder(item)
  }

  labelStatus(item: FornecedorCotacaoPortalVm): string {
    return labelStatus(item)
  }

  // Valor zerado é trecho ainda não respondido — mostrar '-' em vez de "R$ 0,00",
  // mesma regra da tela do operador.
  formatCurrency(value: any): string {
    const n = typeof value === 'number' ? value : parseFloat(value)
    if (value == null || isNaN(n) || n === 0) return '-'
    return `R$ ${n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  }

  displayValue(value: any): any {
    return value === null || value === undefined || value === '' ? '-' : value
  }
}
